import {
  EyeGray400Icon,
  EyeCrossLineWhiteIcon,
  AdultsOnlyNormalPositionIcon,
  AdultsOnlyRisingPositionIcon,
  AdultsOnlyBackPositionIcon,
  AdultsOnlySidePositionIcon,
  AdultsOnlyCurvedPositionIcon,
  AdultsOnlyCrossPositionIcon,
  AdultsOnlySeatingPositionIcon,
  AdultsOnlyStandingPositionIcon,
  AdultsOnlyFellatioIcon,
  AdultsOnlyCunnilingusIcon,
  AdultsOnlyFingeringIcon,
  AdultsOnlyPosition69Icon,
  AdultsOnlyFemaleMasturbationIcon,
  AdultsOnlyMaleMasturbationIcon,
  AdultsOnlyPaizuriIcon,
  AdultsOnlyUndressingShowerIcon,
  AdultsOnlyThreesomeOrgyIcon,
  AdultsOnlyBdsmIcon,
  AdultsOnlyForeplayIcon,
  AdultsOnlyErectionIcon,
  AdultsOnlyKissIcon,
  AdultsOnlyFemaleBodyEmphasisIcon,
  RadioSelectedIcon,
  RadioUnselectedIcon,
  ChevronDownGray600Icon,
  ChevronRightGray600Icon,
  ToggleOnIcon,
  ToggleOffIcon,
  XGray400Icon,
  AdultsOnlyKissingCoupleSmallIcon
} from '@assets/iconComponents';
import {
  Chip,
  MenuTop,
  Output,
  RadioItem,
  Text,
  Select,
  SearchResetButton,
  CheckboxItem,
  TagSearchInput,
  CharacterNumberInput,
  SearchInput,
  Frame
} from '@components';
import {
  ChipPaperType,
  FemaleBodyChildOptionValueEnum,
  SexualBodyPartChildOptionValueEnum,
  SexualPositionChildOptionValueEnum,
  OutputSortTypeEnum,
  styleConstant,
  AdultsOnlyGenreValueEnum,
  AdultsOnlyShotChildOptionValueEnum,
  HorizontalAngleChildOptionValueEnum,
  VerticalAngleChildOptionValueEnum,
  SelectedComicOptionEnum,
  CharacterNumberInputType
} from '@constant';
import { RadioGroup, MenuItem, Radio, styled } from '@mui/material';
import { useComic, useOutput, useMetaTag, useAdultsOnly } from '@hooks';
import { colorSet } from '@theme';
import { useEffect, useRef, useState } from 'react';
import { useAdultsOnlyActions, useComicActions, useMetaTagActions } from '@remote-hooks';

// 스크롤바 커스터마이징을 위해 MUI styled component 이용
const LeftContainer = styled('div')({
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  display: 'flex', // 체위 항목 height 채우기 위해 적용
  flexDirection: 'column', // 체위 항목 height 채우기 위해 적용

  '&::-webkit-scrollbar': {
    width: '8px',
    height: '0px'
  },

  '&::-webkit-scrollbar-thumb': {
    borderRadius: '8px',
    backgroundColor: colorSet.primaryMain
  },

  '&::-webkit-scrollbar-track': {
    borderRadius: '8px',
    backgroundColor: colorSet.gray200,
    margin: '4px 0px'
  }
});

const AdultsOnlyOutputPage = () => {
  const { sectionExpandStates, handleSectionExpand, handleComicSearchToggle, isComicSectionExpanded, isComicToggleOn } =
    useAdultsOnly();

  const {
    initComic,
    selectedOption,
    handleOptionChange,
    selectedGenreList,
    handleGenreToggle,
    isGenreSelected,
    selectedComicNameList,
    inputKeyword,
    autocompleteList,
    handleKeyDown,
    handleInputKeywordChange,
    handleAutocompleteChange,
    handleComicTagClear
  } = useComic();

  const {
    selectedMetaTags,
    tagInputKeyword,
    handleTagKeyDown,
    handleTagInputKeywordChange,
    tagAutocompleteList,
    handleTagAutocompleteChange,
    handleSingleTagClear,
    handleTagClear,
    handleTagSubmit
  } = useMetaTag();

  const scrollToTop = () => {
    if (rightContainerRef.current) {
      rightContainerRef.current.scrollTop = 0;
    }
  };

  const { data, storedAdultsOnly, onSetAdultsOnly, handleIncludeUsedToggle, handleIncludeOtherUsersUsedToggle } =
    useOutput(scrollToTop);

  // 마운트 상태를 추적하는 state
  const [isComponentMounted, setIsComponentMounted] = useState(false);
  // 좌측 사이드바의 스크롤바 여부에 따른 CSS 분기를 위한 상태
  const [hasScrollbar, setHasScrollbar] = useState(false);
  // auto hide navbar 관련 state
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const leftContainerRef = useRef<HTMLDivElement>(null);
  const rightContainerRef = useRef<HTMLDivElement>(null);

  // AdultsOnlyGenreValueEnum의 값들을 배열로 변환
  const genreOptions = Object.values(AdultsOnlyGenreValueEnum);

  // 정렬 기준 Select 컴포넌트의 value를 영어가 아닌 한국어로 보여주기 위한 변수
  const SORT_LABELS: Record<OutputSortTypeEnum, string> = {
    [OutputSortTypeEnum.RANDOM]: '랜덤순',
    [OutputSortTypeEnum.LOW_USAGE]: '사용량 낮음'
  };

  const { onInitComic } = useComicActions();
  const { onInitMetaTag } = useMetaTagActions();
  const { onInitAdultsOnly } = useAdultsOnlyActions();

  useEffect(() => {
    setIsComponentMounted(true);
    if (!isComponentMounted) return;

    return () => {
      onInitComic();
      onInitMetaTag();
      onInitAdultsOnly();
    };
  }, [isComponentMounted, onInitComic, onInitMetaTag, onInitAdultsOnly]);

  // 좌측 사이드바의 스크롤바 존재 여부 체크
  useEffect(() => {
    const checkScrollbar = () => {
      if (leftContainerRef.current) {
        const element = leftContainerRef.current;
        const hasVerticalScrollbar = element.scrollHeight > element.clientHeight;
        setHasScrollbar(hasVerticalScrollbar);
      }
    };

    // 초기 체크를 약간 지연시켜 DOM이 완전히 렌더링된 후 실행
    const timeoutId = setTimeout(checkScrollbar, 100);

    // 리사이즈 이벤트 리스너
    window.addEventListener('resize', checkScrollbar);

    // MutationObserver로 DOM 변화 감지
    const observer = new MutationObserver(checkScrollbar);
    if (leftContainerRef.current) {
      observer.observe(leftContainerRef.current, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', checkScrollbar);
      observer.disconnect();
    };
  }, []);

  // auto hide navbar 스크롤 이벤트 핸들러
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = rightContainerRef.current?.scrollTop || 0;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // 아래로 스크롤하고 100px 이상 스크롤했을 때 navbar 숨기기
        setIsNavbarVisible(false);
      } else if (currentScrollY < lastScrollY) {
        // 위로 스크롤할 때 navbar 보이기
        setIsNavbarVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    const rightContainer = rightContainerRef.current;
    if (rightContainer) {
      rightContainer.addEventListener('scroll', handleScroll);
      return () => rightContainer.removeEventListener('scroll', handleScroll);
    }
  }, [lastScrollY]);

  return (
    <>
      <MenuTop />

      <div
        style={{
          height: `calc(100vh - ${styleConstant.menuTopHeight}px)`,
          display: 'flex',
          flexDirection: 'row'
        }}
      >
        {/* 좌측 메뉴 */}
        <div
          style={{
            width: '352px',
            height: '100%',
            paddingRight: hasScrollbar ? '8px' : '0px' //스크롤바 우측 패딩
          }}
        >
          <LeftContainer ref={leftContainerRef}>
            {/* 제목 & 장르 및 작품명 & 관련 태그 */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
                padding: `24px ${hasScrollbar ? '8px' : '16px'} 20px 16px`
              }}
            >
              {/* 제목 */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Text variant="h2" fontWeight="bold">
                  19금
                </Text>
              </div>
              {/* 장르 및 작품명 */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                  >
                    <div
                      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                      onClick={() => handleSectionExpand('comic')}
                    >
                      {isComicSectionExpanded ? <ChevronDownGray600Icon /> : <ChevronRightGray600Icon />}
                    </div>
                    <Text variant="subtitle" fontWeight="bold">
                      작품 정보로 검색
                    </Text>
                  </div>
                  <div
                    onClick={() => {
                      initComic();
                      handleComicSearchToggle();
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {isComicToggleOn ? <ToggleOnIcon /> : <ToggleOffIcon />}
                  </div>
                </div>
                {isComicSectionExpanded ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', position: 'relative' }}>
                    {/* 장르 */}
                    <div>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '8px' }}>
                        <Radio
                          disabled={!isComicToggleOn}
                          checked={selectedOption === SelectedComicOptionEnum.GENRE}
                          onChange={() => {
                            handleOptionChange(SelectedComicOptionEnum.GENRE);
                          }}
                          checkedIcon={<RadioSelectedIcon style={{ width: 20, height: 20 }} />}
                          icon={<RadioUnselectedIcon style={{ width: 20, height: 20 }} />}
                        />
                        <Text variant="subtitle">장르</Text>
                      </div>
                      <Select
                        disabled={selectedOption !== SelectedComicOptionEnum.GENRE}
                        multiple={true}
                        value={selectedGenreList}
                        renderValue={(selected: any) => {
                          if (selected && selected.length > 0) {
                            return selected.join(', ');
                          } else {
                            return (
                              <Text variant="body1" color={colorSet.gray400}>
                                {selectedOption !== SelectedComicOptionEnum.GENRE
                                  ? '작품명 입력 시 장르는 자동 선택됩니다.'
                                  : '장르를 1개 이상 선택해주세요.'}
                              </Text>
                            );
                          }
                        }}
                        boxstyle={{ width: '100%' }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              maxHeight: 386,
                              '&::-webkit-scrollbar': {
                                width: '8px',
                                height: '0px'
                              },
                              '&::-webkit-scrollbar-thumb': {
                                borderRadius: '8px',
                                backgroundColor: colorSet.primaryMain
                              },
                              '&::-webkit-scrollbar-track': {
                                borderRadius: '8px',
                                backgroundColor: colorSet.gray200
                              },
                              '& .MuiMenuItem-root.Mui-selected': {
                                backgroundColor: colorSet.white
                              }
                            }
                          }
                        }}
                      >
                        <MenuItem value={''} disabled>
                          장르
                        </MenuItem>
                        {genreOptions.map((genre) => (
                          <MenuItem key={genre} value={genre} onClick={() => handleGenreToggle(genre)}>
                            <CheckboxItem
                              label={genre}
                              isChecked={isGenreSelected(genre)}
                              onChange={() => {
                                //onClick은 MenuItem에만 적용
                              }}
                            />
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                    {/* 작품명 */}
                    <div>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '8px' }}>
                        <Radio
                          disabled={!isComicToggleOn}
                          checked={selectedOption === SelectedComicOptionEnum.COMIC_NAME}
                          onChange={() => {
                            handleOptionChange(SelectedComicOptionEnum.COMIC_NAME);
                          }}
                          checkedIcon={<RadioSelectedIcon style={{ width: 20, height: 20 }} />}
                          icon={<RadioUnselectedIcon style={{ width: 20, height: 20 }} />}
                        />
                        <Text variant="subtitle">작품명</Text>
                      </div>
                      <TagSearchInput
                        placeholder={
                          selectedOption !== SelectedComicOptionEnum.COMIC_NAME
                            ? '장르 선택 시 작품은 전체 검색됩니다.'
                            : '작품명 입력 후 엔터를 누르세요.'
                        }
                        tags={selectedComicNameList}
                        inputValue={inputKeyword}
                        options={autocompleteList}
                        onKeyDown={handleKeyDown}
                        onInputChange={handleInputKeywordChange}
                        onAutocompleteChange={handleAutocompleteChange}
                        onTagClear={handleComicTagClear}
                        disabled={selectedOption !== SelectedComicOptionEnum.COMIC_NAME}
                        boxstyle={{ width: '100%' }}
                      />
                    </div>
                    {!isComicToggleOn ? (
                      <div
                        style={{
                          width: '100%', // 부모 div의 너비를 채우도록 설정
                          height: '100%', // 부모 div의 높이를 채우도록 설정
                          borderRadius: '6px',
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          backgroundColor: 'rgba(255, 255, 255, 0.4)'
                        }}
                      />
                    ) : null}
                  </div>
                ) : null}
              </div>
              {/* 관련 태그 */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: '6px'
                  }}
                >
                  <div
                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                    onClick={() => handleSectionExpand('tag')}
                  >
                    {sectionExpandStates.tag ? <ChevronDownGray600Icon /> : <ChevronRightGray600Icon />}
                  </div>
                  <Text variant="subtitle" fontWeight="bold">
                    관련 태그
                  </Text>
                </div>
                {sectionExpandStates.tag ? (
                  <div>
                    <SearchInput
                      placeholder="태그 입력 후 스페이스바를 누르세요."
                      value={tagInputKeyword}
                      options={tagAutocompleteList}
                      onKeyDown={handleTagKeyDown}
                      onInputChange={handleTagInputKeywordChange}
                      onAutocompleteChange={handleTagAutocompleteChange}
                      onClear={handleTagClear}
                      onSubmit={handleTagSubmit}
                      showTwoSubIcons={true}
                    />
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: `4px`,
                        width: '100%',
                        boxSizing: 'border-box',
                        marginTop: selectedMetaTags && selectedMetaTags.length > 0 ? 10 : 0
                      }}
                    >
                      {selectedMetaTags && selectedMetaTags.length > 0
                        ? selectedMetaTags.map((item, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  height: 28,
                                  border: `1px solid ${colorSet.gray300}`,
                                  borderRadius: '6px',
                                  padding: '0px 10px',
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                <Text variant="body1" marginRight="2px">
                                  {item}
                                </Text>
                                <XGray400Icon
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    handleSingleTagClear(item);
                                  }}
                                />
                              </div>
                            );
                          })
                        : null}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            {/* 체위 */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                padding: '20px 0px 40px 16px',
                backgroundColor: colorSet.gray100,
                flex: 1 // 남은 공간을 모두 차지
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                <div
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                  onClick={() => handleSectionExpand('sexualPosition')}
                >
                  {sectionExpandStates.sexualPosition ? <ChevronDownGray600Icon /> : <ChevronRightGray600Icon />}
                </div>
                <Text variant="subtitle" fontWeight="bold">
                  체위
                </Text>
              </div>
              {sectionExpandStates.sexualPosition ? (
                <RadioGroup
                  value={storedAdultsOnly.sexualPosition}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    onSetAdultsOnly({
                      sexualPosition: event.target.value as SexualPositionChildOptionValueEnum
                    });
                  }}
                >
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3, 1fr)', // 2열
                      gridTemplateRows: 'repeat(8, auto)', // 8행
                      gap: '24px 0px'
                    }}
                  >
                    <RadioItem
                      label="전체 선택"
                      value={SexualPositionChildOptionValueEnum['모든 체위']}
                      imageComponent={<AdultsOnlyKissingCoupleSmallIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="정상위"
                      value={SexualPositionChildOptionValueEnum['정상위']}
                      imageComponent={<AdultsOnlyNormalPositionIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="기승위"
                      value={SexualPositionChildOptionValueEnum['기승위']}
                      imageComponent={<AdultsOnlyRisingPositionIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="후배위"
                      value={SexualPositionChildOptionValueEnum['후배위']}
                      imageComponent={<AdultsOnlyBackPositionIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="측위"
                      value={SexualPositionChildOptionValueEnum['측위']}
                      imageComponent={<AdultsOnlySidePositionIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="굴곡위"
                      value={SexualPositionChildOptionValueEnum['굴곡위']}
                      imageComponent={<AdultsOnlyCurvedPositionIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="교차위"
                      value={SexualPositionChildOptionValueEnum['교차위']}
                      imageComponent={<AdultsOnlyCrossPositionIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="좌위"
                      value={SexualPositionChildOptionValueEnum['좌위']}
                      imageComponent={<AdultsOnlySeatingPositionIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="입위"
                      value={SexualPositionChildOptionValueEnum['입위']}
                      imageComponent={<AdultsOnlyStandingPositionIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="펠라치오"
                      value={SexualPositionChildOptionValueEnum['펠라치오']}
                      imageComponent={<AdultsOnlyFellatioIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="커닐링구스"
                      value={SexualPositionChildOptionValueEnum['커닐링구스']}
                      imageComponent={<AdultsOnlyCunnilingusIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="핑거링"
                      value={SexualPositionChildOptionValueEnum['핑거링']}
                      imageComponent={<AdultsOnlyFingeringIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="69체위"
                      value={SexualPositionChildOptionValueEnum['69체위']}
                      imageComponent={<AdultsOnlyPosition69Icon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="여성자위"
                      value={SexualPositionChildOptionValueEnum['여성자위']}
                      imageComponent={<AdultsOnlyFemaleMasturbationIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="남성자위"
                      value={SexualPositionChildOptionValueEnum['남성자위']}
                      imageComponent={<AdultsOnlyMaleMasturbationIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="파이즈리"
                      value={SexualPositionChildOptionValueEnum['파이즈리']}
                      imageComponent={<AdultsOnlyPaizuriIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="탈의/샤워"
                      value={SexualPositionChildOptionValueEnum['탈의/샤워']}
                      imageComponent={<AdultsOnlyUndressingShowerIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="쓰리썸/난교"
                      value={SexualPositionChildOptionValueEnum['쓰리썸/난교']}
                      imageComponent={<AdultsOnlyThreesomeOrgyIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="BDSM"
                      value={SexualPositionChildOptionValueEnum['BDSM']}
                      imageComponent={<AdultsOnlyBdsmIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="애무"
                      value={SexualPositionChildOptionValueEnum['애무']}
                      imageComponent={<AdultsOnlyForeplayIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="발기"
                      value={SexualPositionChildOptionValueEnum['발기']}
                      imageComponent={<AdultsOnlyErectionIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="키스"
                      value={SexualPositionChildOptionValueEnum['키스']}
                      imageComponent={<AdultsOnlyKissIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                    <RadioItem
                      label="여체 강조"
                      value={SexualPositionChildOptionValueEnum['여체 강조']}
                      imageComponent={<AdultsOnlyFemaleBodyEmphasisIcon style={{ width: 56, height: 56 }} />}
                      onChange={(value) => {
                        onSetAdultsOnly({
                          sexualPosition: value as SexualPositionChildOptionValueEnum
                        });
                      }}
                    />
                  </div>
                </RadioGroup>
              ) : null}
            </div>
          </LeftContainer>
        </div>

        <div style={{ height: '100%', borderRight: `1px solid ${colorSet.gray300}` }} />

        {/* 우측 이미지 리스트 */}
        <div
          ref={rightContainerRef}
          className="hide-scrollbar"
          style={{
            flex: 1,
            height: '100%',
            backgroundColor: colorSet.white,
            overflowY: 'auto'
          }}
        >
          {/* 상단: 필터 초기화 & Chip */}
          <div
            id="auto-hide-navbar"
            style={{
              width: '100%',
              position: 'sticky',
              top: 0,
              backgroundColor: colorSet.white,
              padding: '24px 40px',
              zIndex: styleConstant.zIndexTopFilter,
              transform: isNavbarVisible ? 'translateY(0)' : 'translateY(-100%)',
              transition: 'transform 0.3s ease-in-out'
            }}
          >
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: `12px`,
                width: '100%',
                boxSizing: 'border-box'
              }}
            >
              <SearchResetButton boxstyle={{ display: 'flex', alignItems: 'center' }} />
              <Chip
                label="여체"
                paperType={ChipPaperType.CHECKBOX_LIST}
                options={{
                  슬랜더: { name: '슬랜더', value: FemaleBodyChildOptionValueEnum['슬랜더'], isSelected: false },
                  글래머: { name: '글래머', value: FemaleBodyChildOptionValueEnum['글래머'], isSelected: false },
                  슈퍼글래머: {
                    name: '슈퍼글래머',
                    value: FemaleBodyChildOptionValueEnum['슈퍼글래머'],
                    isSelected: false
                  },
                  통통: { name: '통통', value: FemaleBodyChildOptionValueEnum['통통'], isSelected: false }
                }}
                storedChildOptionValue={storedAdultsOnly.femaleBody}
                setSelectedOption={(param) => {
                  onSetAdultsOnly({ femaleBody: param });
                }}
              />
              <Chip
                label="신체 부위"
                paperType={ChipPaperType.CHECKBOX_LIST}
                options={{
                  가슴: { name: '가슴', value: SexualBodyPartChildOptionValueEnum['가슴'], isSelected: false },
                  엉덩이: { name: '엉덩이', value: SexualBodyPartChildOptionValueEnum['엉덩이'], isSelected: false },
                  '여자 성기': {
                    name: '여자 성기',
                    value: SexualBodyPartChildOptionValueEnum['여자 성기'],
                    isSelected: false
                  },
                  '남자 성기': {
                    name: '남자 성기',
                    value: SexualBodyPartChildOptionValueEnum['남자 성기'],
                    isSelected: false
                  },
                  입: {
                    name: '입',
                    value: SexualBodyPartChildOptionValueEnum['입'],
                    isSelected: false
                  },
                  얼굴: {
                    name: '얼굴',
                    value: SexualBodyPartChildOptionValueEnum['얼굴'],
                    isSelected: false
                  }
                }}
                storedChildOptionValue={storedAdultsOnly.sexualBodyPart}
                setSelectedOption={(param) => {
                  onSetAdultsOnly({ sexualBodyPart: param });
                }}
              />
              <CharacterNumberInput
                type={CharacterNumberInputType.CHIP}
                isGenderNumbersOnly={true}
                characterNumber={storedAdultsOnly.characterNumber}
                onApplyClick={(values: {
                  maleNumber?: number | string;
                  femaleNumber?: number | string;
                  wholeGenderNumber?: number | string;
                  isWholeGenderNumberChecked?: boolean;
                }) => {
                  onSetAdultsOnly({ characterNumber: values });
                }}
                onChipXButtonClick={() => {
                  onSetAdultsOnly({ characterNumber: null });
                }}
              />
              <Chip
                label="프레임"
                paperType={ChipPaperType.CHECKBOX_LIST}
                options={{
                  클로즈업: {
                    name: '클로즈업',
                    value: AdultsOnlyShotChildOptionValueEnum['클로즈업'],
                    isSelected: false
                  },
                  미디엄샷: {
                    name: '미디엄샷',
                    value: AdultsOnlyShotChildOptionValueEnum['미디엄샷'],
                    isSelected: false
                  },
                  풀샷: {
                    name: '풀샷',
                    value: AdultsOnlyShotChildOptionValueEnum['풀샷'],
                    isSelected: false
                  }
                }}
                storedChildOptionValue={storedAdultsOnly.shot}
                setSelectedOption={(param) => {
                  onSetAdultsOnly({ shot: param });
                }}
              />
              <Chip
                label="가로앵글"
                paperType={ChipPaperType.CHECKBOX_LIST}
                options={{
                  정면: { name: '정면', value: HorizontalAngleChildOptionValueEnum['정면'], isSelected: false },
                  정측면: {
                    name: '정측면',
                    value: HorizontalAngleChildOptionValueEnum['정측면'],
                    isSelected: false
                  },
                  측면: { name: '측면', value: HorizontalAngleChildOptionValueEnum['측면'], isSelected: false },
                  후측면: {
                    name: '후측면',
                    value: HorizontalAngleChildOptionValueEnum['후측면'],
                    isSelected: false
                  },
                  후면: { name: '후면', value: HorizontalAngleChildOptionValueEnum['후면'], isSelected: false }
                }}
                storedChildOptionValue={storedAdultsOnly.horizontalAngle}
                setSelectedOption={(param) => {
                  onSetAdultsOnly({ horizontalAngle: param });
                }}
              />
              <Chip
                label="세로앵글"
                paperType={ChipPaperType.CHECKBOX_LIST}
                options={{
                  로우앵글: {
                    name: '로우앵글',
                    value: VerticalAngleChildOptionValueEnum['로우앵글'],
                    isSelected: false
                  },
                  하이앵글: {
                    name: '하이앵글',
                    value: VerticalAngleChildOptionValueEnum['하이앵글'],
                    isSelected: false
                  },
                  항공샷: {
                    name: '항공샷',
                    value: VerticalAngleChildOptionValueEnum['항공샷'],
                    isSelected: false
                  },
                  평시각: {
                    name: '평시각',
                    value: VerticalAngleChildOptionValueEnum['평시각'],
                    isSelected: false
                  }
                }}
                storedChildOptionValue={storedAdultsOnly.verticalAngle}
                setSelectedOption={(param) => {
                  onSetAdultsOnly({ verticalAngle: param });
                }}
              />
            </div>
          </div>
          {/* 중간 필터 & 검색 결과 */}
          <Frame width="100%" padding="0px 40px 96px 40px">
            {/* 19금 Output페이지 태그 검색시 상단에 선택된 태그들과 검색결과 갯수 */}
            {selectedMetaTags && selectedMetaTags.length > 0 ? (
              <div style={{ display: 'flex', marginTop: '24px', marginBottom: '20px' }}>
                {selectedMetaTags.map((item, index) => {
                  if (selectedMetaTags && index === selectedMetaTags.length - 1) {
                    return (
                      <div key={index} style={{ display: 'flex' }}>
                        <Text variant="h3" fontWeight="bold" color="primary">
                          &apos;{item}&apos;
                        </Text>
                        <Text variant="h3" fontWeight="bold">
                          &nbsp;
                        </Text>
                      </div>
                    );
                  } else {
                    return (
                      <div key={index} style={{ display: 'flex' }}>
                        <Text variant="h3" fontWeight="bold" color="primary">
                          &apos;{item}&apos;
                        </Text>
                        <Text variant="h3" fontWeight="bold">
                          ,&nbsp;
                        </Text>
                      </div>
                    );
                  }
                })}
                <Text variant="h3" fontWeight="bold">
                  태그가 포함된 이미지{' '}
                  {data?.pages[0].data.meta?.itemCount ? data?.pages[0].data.meta?.itemCount.toLocaleString() : 0}장
                </Text>
              </div>
            ) : null}

            {/* 중간 필터 */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                marginBottom: '20px'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 12
                }}
              >
                <div
                  onClick={handleIncludeUsedToggle}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 4,
                    padding: '8px 24px',
                    alignItems: 'center',
                    borderRadius: '22px',
                    border: storedAdultsOnly.isIncludeUsed ? `1px solid ${colorSet.gray400}` : 'none',
                    cursor: 'pointer',
                    backgroundColor: storedAdultsOnly.isIncludeUsed ? 'transparent' : colorSet.gray600
                  }}
                >
                  {storedAdultsOnly.isIncludeUsed ? <EyeGray400Icon /> : <EyeCrossLineWhiteIcon />}
                  <Text
                    variant="body2"
                    color={storedAdultsOnly.isIncludeUsed ? colorSet.gray400 : colorSet.white}
                    fontWeight={storedAdultsOnly.isIncludeUsed ? 400 : 700}
                  >
                    내가 사용한 이미지
                  </Text>
                </div>
                <div
                  onClick={handleIncludeOtherUsersUsedToggle}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 4,
                    padding: '8px 24px',
                    alignItems: 'center',
                    borderRadius: '22px',
                    border: storedAdultsOnly.isIncludeOtherUsersUsed ? `1px solid ${colorSet.gray400}` : 'none',
                    cursor: 'pointer',
                    backgroundColor: storedAdultsOnly.isIncludeOtherUsersUsed ? 'transparent' : colorSet.gray600
                  }}
                >
                  {storedAdultsOnly.isIncludeOtherUsersUsed ? <EyeGray400Icon /> : <EyeCrossLineWhiteIcon />}
                  <Text
                    variant="body2"
                    color={storedAdultsOnly.isIncludeOtherUsersUsed ? colorSet.gray400 : colorSet.white}
                    fontWeight={storedAdultsOnly.isIncludeOtherUsersUsed ? 400 : 700}
                  >
                    남이 사용한 이미지
                  </Text>
                </div>
              </div>
              <Select
                value={storedAdultsOnly.sortType}
                renderValue={(value) => {
                  const sortType = value as OutputSortTypeEnum;
                  return SORT_LABELS[sortType] || '정렬 기준';
                }}
                onChange={(e) => {
                  onSetAdultsOnly({ sortType: e.target.value });
                }}
                boxstyle={{ width: 160 }}
              >
                <MenuItem value={''} disabled>
                  정렬 기준
                </MenuItem>
                <MenuItem value={OutputSortTypeEnum.RANDOM}>랜덤순</MenuItem>
                <MenuItem value={OutputSortTypeEnum.LOW_USAGE}>사용량 낮음</MenuItem>
              </Select>
            </div>
            <Output padding="0" />
          </Frame>
        </div>
      </div>
    </>
  );
};

export default AdultsOnlyOutputPage;
